// Classifies a lineItems array by item.isDigital:
//   true      -> every item is digital
//   false     -> every item is physical
//   "mixed"   -> a combination of both
//   "not_found" -> at least one item is missing the isDigital key
export const getDigitalStatus = (items) => {
  const hasMissingKey = items?.some(
    item => item?.isDigital === undefined
  );

  if (hasMissingKey) return "not_found";

  const allTrue = items?.every(item => item?.isDigital);
  const allFalse = items?.every(item => !item?.isDigital);

  if (allTrue) return true;
  if (allFalse) return false;

  return "mixed";
};
